module.exports = "/_next/static/images/transfez-logo-0bd07bb03d3faf5407134a69abc28c69.svg";